import { makeStyles } from '@material-ui/core/styles';

// Figma "Payment schedule modal": 720px wide.
const MODAL_WIDTH = 720;

export default makeStyles((theme) => ({
  dialog: {
    maxWidth: MODAL_WIDTH,
    borderRadius: theme.sizes.roundCorners
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(6)
  },
  title: {
    margin: 0
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  sectionHeading: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    gap: theme.spacing(4)
  },
  heading: {
    margin: 0,
    lineHeight: '24px',
    color: theme.colorPalette.green_100
  },
  summary: {
    margin: 0,
    lineHeight: '20px',
    color: theme.colorPalette.green_90
  },
  table: {
    width: '100%',
    tableLayout: 'fixed',
    borderCollapse: 'collapse',
    fontFamily: 'inherit',
    color: theme.colorPalette.green_90,
    '& th, & td': {
      padding: theme.spacing(2, 4),
      textAlign: 'left',
      verticalAlign: 'middle'
    },
    '& th': {
      fontSize: 10,
      fontWeight: 400,
      lineHeight: '12px',
      textTransform: 'uppercase'
    },
    '& td': {
      fontSize: 12,
      lineHeight: '16px'
    },
    '& tbody tr:nth-child(odd)': {
      backgroundColor: theme.colorPalette.beige_40
    },
    '& td$amount': {
      fontSize: 14,
      lineHeight: '20px'
    }
  },
  amount: {
    '&&': {
      textAlign: 'right'
    }
  },
  dueAtBind: {
    marginLeft: theme.spacing(2),
    fontStyle: 'italic',
    color: theme.colorPalette.green_75
  },
  termTotal: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4)
  },
  divider: {
    margin: 0,
    '&::before, &::after': {
      backgroundColor: theme.colorPalette.green_75,
      opacity: 0.5
    }
  },
  termTotalRow: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: theme.spacing(2),
    padding: theme.spacing(0, 4)
  },
  termTotalLabel: {
    flex: 1,
    lineHeight: '16px'
  },
  termTotalValue: {
    lineHeight: '20px',
    whiteSpace: 'nowrap'
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end'
  }
}));
